document.addEventListener("DOMContentLoaded", function () {

  console.log("🔥 FINAL PRICE BREAK RUNNING");

  const body = document.getElementById("price-break-body");
  const variants = JSON.parse(document.getElementById("variant-data").textContent);

  function getSelectedOptions() {
    let values = [];

    document.querySelectorAll('select[name^="options"]').forEach((s) => {
      values.push(s.value);
    });

    document.querySelectorAll('input[type="radio"]:checked').forEach((r) => {
      if (r.name.includes("options")) values.push(r.value);
    });

    return values;
  }

  function renderTable() {

    const selected = getSelectedOptions();
    console.log("Selected:", selected);

    body.innerHTML = "";

    let rows = [];

    variants.forEach((v) => {

      let matchAll = true;

      // 👉 Dynamic option matching (except pack)
      v.options.forEach((opt, i) => {
        // skip last option (pack)
        if (i === v.options.length - 1) return;

        if (selected[i] && selected[i] !== opt) {
          matchAll = false;
        }
      });

      if (!matchAll) return;

      // 👉 Extract quantity from pack
      const packText = v.options[v.options.length - 1];
      const match = packText.match(/(\d+)/);
      const qty = match ? parseInt(match[1]) : 1;

      const price = v.price / 100;
      const each = price / qty;

      rows.push({
        qty,
        each,
        variant: v
      });
    });

    // 👉 Sort
    rows.sort((a, b) => a.qty - b.qty);

    // 👉 Best value
    let minPrice = Math.min(...rows.map(r => r.each));

    rows.forEach((row) => {

      const isBest = row.each === minPrice;

      body.innerHTML += `
        <tr>
          <td>
            Pack of ${row.qty}
            ${isBest ? '<span style="background:#eee;padding:2px 6px;border-radius:10px;font-size:12px;">Best value</span>' : ''}
          </td>
          <td>£${row.each.toFixed(2)}</td>
        </tr>
      `;
    });

    if (!rows.length) {
      body.innerHTML = "<tr><td colspan='2'>No data</td></tr>";
    }
  }

  // init
  renderTable();

  // update on change
  document.addEventListener("change", function () {
    renderTable();
  });

});